import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/LeasedEquipmentConfiguration";

export const getLeasedEquipmentSupplyAlertProfileList = async () => {
  return axios.get(`${api_base_url}/GetSupplyAlertProfile`).then((res) => {
    return res;
  });
};

export const addLeasedEquipmentSupplyAlertProfile = async (newSupplyAlertProfile) => {
  const { data } = await axios.post(`${api_base_url}/AddSupplyAlertProfile`, {
    ...newSupplyAlertProfile,
  });
  return data;
};

export const deleteLeasedEquipmentSupplyAlertProfile = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateSupplyAlertProfile`, {
    data: ids,
  });
  return data;
};

export const updateLeasedEquipmentSupplyAlertProfile = async (editLeasedEquipmentSupplyAlertProfile) => {
  const { data } = await axios.put(
    `${api_base_url}/EditSupplyAlertProfile`,
    editLeasedEquipmentSupplyAlertProfile
  );
  return data;
};
